/**
 * 用途：共享标注页面的当前路由及身份绑定。
 * 作者：Codex
 * 创建日期：2026-10-20
 */
/**
 * 只按业务定位识别任务，排除子应用内部导航和展示字段。
 * @param {object} query 当前页面路由参数。
 * @returns {string} 明细、人员、任务包、项目、条目及页面动作的稳定绑定键。
 */
export function entryRouteKey(query) {
  return JSON.stringify([query.taskDetailGuid, query.staffGuid, query.taskPackageGuid,
    query.projectId, query.taskId, query.mode]);
}

/**
 * 生成当前路由、人员与企业的入口绑定。
 * @returns {string} 当前页面身份绑定键。
 * 参数：无。
 */
export function entryKey() {
  return JSON.stringify([entryRouteKey(this.$route.query), localStorage.getItem('userInfo'),
    localStorage.getItem('tenantGuid'), localStorage.getItem('guid'), localStorage.getItem('userId')]);
}
